/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_SuccessInputs */

const he_verify_success = /** @type {(inputs: Verify_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אומת בהצלחה!`)
};

const en_verify_success = /** @type {(inputs: Verify_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Success!`)
};

/**
* | output |
* | --- |
* | "Success!" |
*
* @param {Verify_SuccessInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const verify_success = /** @type {((inputs?: Verify_SuccessInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_SuccessInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_verify_success(inputs)
	return en_verify_success(inputs)
});